import { IRadioButtonChipOptions } from '@components/common/formControl/radioButtonChip';
import { TAccordianDetails } from '@components/siteLeads/components/siteAddress';

export interface IMeetingDetailsType {
	contractorType: string;
	contractorName: string;
	contractorPhoneNumber: string;
	dealerName: string;
	homeOwnerDetails: TAccordianDetails[];
	architectDetails: TAccordianDetails[];
	assigneCmdi?: string;
	role?: string;
	builderDetails: TAccordianDetails[];
}

export const meetingDetailsInitialValues: IMeetingDetailsType = {
	contractorType: '',
	contractorName: '',
	contractorPhoneNumber: '',
	dealerName: '',
	homeOwnerDetails: [{ id: 0, isActive: true, name: '', number: '' }],
	architectDetails: [{ id: 0, isActive: true, name: '', number: '' }],
	assigneCmdi: '',
	role: '',
	builderDetails: [{ id: 0, isActive: true, name: '', number: '', address: '' }],
};

export const ContractorTypeLabel = {
	Contractor: 'Contractor',
	Project_Supervisor: 'Project Supervisor',
	Labourer: 'Labourer',
	NONE: 'NONE',
};

export const contractorTypeList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'Contractor', value: ContractorTypeLabel.Contractor, icon: 'icon-builder-cap' },
	{ id: 2, label: 'Project Supervisor', value: ContractorTypeLabel.Project_Supervisor, icon: 'icon-todo-list' },
	{ id: 3, label: 'NONE', value: ContractorTypeLabel.NONE, icon: 'icon-spade' },
];
